import React, { Component } from 'react';
import { getFeatureFlags } from '../Global/helpers';
import qs from 'qs';
import { pdfjs } from 'react-pdf';
import styles from './CertificateOfCoverage.module.css';
import { Card, CardBody, Container } from 'reactstrap';
import PageLoading from '../shared/PageLoading/PageLoading';
import { SessionContext } from '../../context/SessionContext';
import { getTranslation } from '../../components/Global/helpers';
import { accounts } from '../../components/BrandingWhiteLabel/BrandStyles';
import CertificateOfCoverageError from './CertificateOfCoverageError';
import CertificateCoverage from './CertificateCoverage';
import InvalidCoverageError from './ErrorPages/InvalidCoverageError';
import ExpiredTokenError from './ErrorPages/ExpiredTokenError';

export default class CertificateOfCoverage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contractNumber: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).contractNumber,
            token: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).token,
            languageCode: qs.parse(this.props.location.search, { ignoreQueryPrefix: true }).languageCode ?? 'en',
            expiredToken: false,
            genericExpiredToken: false,
            contractNotFound: false,
            loadingPdf: true,
            showControlledError: false,
            assetDetails: {},
            contractId: 0,
            clientId: undefined
        };
    }

    componentDidMount = async () => {
        var flags = await getFeatureFlags();
        let translationFlag = flags?.find((value) => value.featureFlagName === 'Lennox Translations')?.active ?? false;
        if (
            translationFlag
            && (this.state.languageCode !== 'en'
                || this.state.languageCode !== 'en-us'
                || this.state.languageCode !== 'en-ca')
        ) {
            this.context.useTranslations('ErrorMessages', this.state.languageCode);
            this.context.useTranslationsHeader('Header', this.state.languageCode);
            this.context.useTranslationsFooter('Footer', this.state.languageCode);
        }
        this.context.setPaymentGatewayStatus(true);
        this.handleLoadCertificate();
    };

    updateClientName = (clientId) => {
        //For generic branding we are adding grayscale as client so that its branding will get added
        const existingAccounts = Object.keys(accounts);
        const accountName = clientId?.toLowerCase();
        const clientName = !existingAccounts.includes(accountName) ? 'grayscale' : accountName;
        this.context.updateClientId(clientName);
    };

    updatedCertificateName = (details) => {
        let cocCertificateName = '';
        if (
            details?.certificateName.toLowerCase() === 'hvac'
            || details?.certificateName.toLowerCase() === 'eversafewarranty'
        ) {
            if (details?.accountId === 18) {
                cocCertificateName = 'Lennox';
            } else {
                cocCertificateName = details?.accountNameFull;
            }
        } else if (details?.certificateName.toLowerCase() === 'generic') {
            cocCertificateName = details?.accountNameFull;
        } else {
            cocCertificateName = details?.certificateName;
        }
        return cocCertificateName;
    };

    resendEmail = async () => {
        let printRequestModel = {
            contractId: parseInt(this.state.contractId),
            customerEmailRequest: true,
            languageCode: this.state.languageCode,
            token: this.state.token
        };
        await fetch(`Contract/SendContractFulfillmentEmail/${this.state.clientId}`, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(printRequestModel)
        }).then((res) => {
            if (res?.ok) {
                res.json().then((data) => {
                    // console.log(data);
                });
            }
        });
    };

    updatedCertificateName = (details) => {
        let certificateName = 'AIG';
        if (
            details?.certificateName?.toLowerCase() === 'hvac'
            || details?.certificateName?.toLowerCase() === 'hvacaftermarket'
        ) {
            if (details?.accountId === 18) {
                certificateName = 'Lennox';
            } else {
                certificateName = details?.accountNameFull;
            }
        } else if (details?.certificateName?.toLowerCase() === 'generic') {
            certificateName = 'AIG';
        } else {
            certificateName = details?.certificateName;
        }
        return certificateName;
    };

    handleLoadCertificate = async () => {
        pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
        const tokenResponse = await fetch(`token/VerifyObjectToken/0/${this.state.contractNumber}/${this.state.token}`);
        if (tokenResponse?.status === 200) {
            const tokenData = await tokenResponse?.json();
            // Check if Valid
            if (tokenData?.exists && tokenData?.isValidObject) {
                const certificateDetails = await fetch(
                    `contract/GetCertificateOfCoverageDetails/${this.state.contractNumber}/AIG`,
                    {
                        method: 'get',
                        headers: {
                            'Content-Type': 'application/pdf'
                        }
                    }
                );
                if (certificateDetails?.status === 200) {
                    const details = await certificateDetails?.json();
                    if (details.languageCode) {
                        var flags = await getFeatureFlags();
                        let translationFlag =
                            flags?.find((value) => value.featureFlagName === 'Lennox Translations')?.active ?? false;
                        if (
                            translationFlag
                            && (details.languageCode !== 'en'
                                || details.languageCode !== 'en-us'
                                || details.languageCode !== 'en-ca')
                        ) {
                            this.context.useTranslations('ErrorMessages', details.languageCode);
                            this.context.useTranslationsHeader('Header', details.languageCode);
                            this.context.useTranslationsFooter('Footer', details.languageCode);
                        }
                        this.setState({ languageCode: details.languageCode });
                    }
                    const certName = this.updatedCertificateName(details);

                    this.updateClientName(details?.accountName);
                    this.context.updateCOCCertificateName(certName, details);
                    this.context.isCertificateCoverageHeader(true);
                    if (tokenData?.isConsumed || tokenData?.isExpired) {
                        if (tokenData?.clientId === 'hvac') {
                            this.setState({ expiredToken: true, loadingPdf: false });
                        } else {
                            this.setState({
                                genericExpiredToken: true,
                                loadingPdf: false,
                                contractId: tokenData?.warrantyObjectValue,
                                clientId: tokenData?.clientId
                            });
                        }
                    } else {
                        if (certName !== 'Lennox' && details.certificateId === 0) {
                            this.setState({
                                invalidCoverageError: true,
                                loadingPdf: false,
                                clientId: details?.accountName
                            });
                            return;
                        }
                        this.setState({ assetDetails: details, loadingPdf: false });
                        // Load static page using details
                    }
                } else {
                    this.updateClientName(tokenData?.clientId);
                    if (tokenData?.clientId === 'hvac') {
                        this.setState({ showControlledError: true, loadingPdf: false });
                    } else {
                        this.setState({ invalidCoverageError: true, loadingPdf: false, clientId: 'aig' });
                    }
                    return;
                }
            } else {
                // For future error pages:
                // Check if isValidObject, if not the token was not mapped correctly and should not allow for a resend
                // If isValidObject and token is expired or consumed, they can request an email for a new link (future story possibility)
                this.updateClientName(tokenData?.clientId);
                if (tokenData?.clientId === 'hvac') {
                    this.setState({ showControlledError: true, loadingPdf: false });
                } else {
                    this.setState({ invalidCoverageError: true, loadingPdf: false, clientId: 'aig' });
                }
            }
        } else {
            this.setState({ invalidCoverageError: true, loadingPdf: false, clientId: 'aig' });
        }
    };

    handleTryAgain(statePropsToUpdate) {
        this.setState(statePropsToUpdate);
    }

    render() {
        const { accountName, isTranslationsResolved, translations } = this.context;

        return (
            <div>
                {(!this.state.expiredToken
                    || this.state.genericExpiredToken
                    || !!this.state.assetDetails?.assetDetails?.length)
                    && this.state.loadingPdf && (
                        <Container className='contentWrapper'>
                            <Card>
                                <CardBody className={styles.spinnerCard}>
                                    <PageLoading text='Certificate is Loading' />
                                </CardBody>
                            </Card>
                        </Container>
                    )}
                {(this.state.languageCode === 'fr-us' || this.state.languageCode === 'fr-ca')
                    && Object.keys(translations)?.length === 0
                    && this.state.loadingPdf && (
                        <Container className='contentWrapper'>
                            <Card>
                                <CardBody className={styles.spinnerCard}>
                                    <PageLoading text='Certificate is Loading' />
                                </CardBody>
                            </Card>
                        </Container>
                    )}
                {this.state.expiredToken && (
                    <CertificateOfCoverageError
                        accountName={accountName}
                        styles={styles}
                        handleTryAgain={() => this.handleTryAgain({ loadingPdf: true, showControlledError: false })}
                        handleLoadCertificate={this.handleLoadCertificate}
                        expiredToken={true}
                        languageCode={this.state.languageCode}
                    />
                )}

                {this.state.genericExpiredToken && (
                    <ExpiredTokenError
                        accountName={accountName}
                        styles={styles}
                        handleTryAgain={() => this.handleTryAgain({ loadingPdf: true, showControlledError: false })}
                        handleResendEmail={this.resendEmail}
                        genericExpiredToken={true}
                        languageCode={this.state.languageCode}
                    />
                )}

                {this.state.assetDetails?.assetDetails?.length && (
                    <CertificateCoverage
                        assetDetails={this.state.assetDetails}
                        styles={styles}
                        languageCode={this.state.languageCode}
                    />
                )}

                {this.state.showControlledError && !this.state.expiredTokens && (
                    <CertificateOfCoverageError
                        accountName={accountName}
                        styles={styles}
                        handleTryAgain={() => this.handleTryAgain({ loadingPdf: true, showControlledError: false })}
                        handleLoadCertificate={this.handleLoadCertificate}
                        expiredToken={false}
                        languageCode={this.state.languageCode}
                    />
                )}

                {this.state.invalidCoverageError && (
                    <InvalidCoverageError
                        accountName={accountName}
                        styles={styles}
                        handleLoadCertificate={this.handleLoadCertificate}
                        genericExpiredToken={false}
                        languageCode={this.state.languageCode}
                        clientId={this.state.clientId}
                    />
                )}
            </div>
        );
    }
}

CertificateOfCoverage.contextType = SessionContext;
